import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Goatopimprichichwad() {



const cardData =
{
  keyword: 'Goa to Pimpri Chinchwad Cab ',

  heading: 'Lotus Cab: Goa to Pimpri Chinchwad Cab ',

headingDescription:
  "Lotus Cabs offers reliable and affordable Goa to Pimpri Chinchwad Cab services for family travel, corporate trips, business meetings, airport transfers, student travel, holiday tours, and one-way or round-trip journeys. Our premium fleet includes Sedan, SUV, Innova Crysta, Ertiga, Kia Carens, Tempo Traveller, Luxury Urbania, and Mini Bus, driven by professional and experienced chauffeurs to ensure a safe and comfortable journey. With 24x7 booking support, transparent pricing, doorstep pickup from any location in Goa, clean and well-maintained vehicles, and dependable long-distance highway travel, Lotus Cabs guarantees a smooth, convenient, and hassle-free travel experience from Goa to Pimpri Chinchwad.",


  top: 'Top Places to Visit in Pune before Traveling to Goa with Lotus Cab',

topPlaces: [
       {
        title: "Raja Dinkar Kelkar Museum",
        description:
            "Raja Dinkar Kelkar Museum showcases one of India's finest collections of traditional artifacts, antique furniture, sculptures, musical instruments, paintings, and household items. The museum offers visitors an enriching journey through India's artistic and cultural heritage."
    },
    {
        title: "Pataleshwar Cave Temple",
        description:
            "Pataleshwar Cave Temple is an ancient 8th-century rock-cut Shiva temple situated in the heart of Pune. Known for its remarkable stone architecture, intricate carvings, and tranquil surroundings, it is an important religious and historical attraction."
    },
    {
        title: "Rajiv Gandhi Zoological Park",
        description:
            "Rajiv Gandhi Zoological Park is a popular family destination featuring a diverse collection of wildlife, reptiles, birds, and a dedicated snake park. The well-maintained zoo provides educational and recreational experiences for visitors of all ages."
    },
    {
        title: "Pashan Lake",
        description:
            "Pashan Lake is a peaceful urban lake famous for its walking trails, migratory birds, and scenic natural surroundings. Birdwatchers, photographers, and morning walkers frequently visit this beautiful location for a refreshing escape from the city's busy lifestyle."
    },
     {
        title: "Shaniwar Wada",
        description:
            "Shaniwar Wada is Pune's most iconic historical monument and a symbol of the glorious Maratha Empire. Built in 1732 as the seat of the Peshwas, the fort features magnificent gateways, impressive architecture, landscaped gardens, and an evening light and sound show, making it a must-visit heritage attraction."
    },
    {
        title: "Shreemant Dagdusheth Halwai Ganpati Temple",
        description:
            "Shreemant Dagdusheth Halwai Ganpati Temple is one of Maharashtra's most revered Lord Ganesha temples. Famous for its beautifully decorated idol, vibrant festivals, and peaceful spiritual atmosphere, the temple attracts thousands of devotees and tourists throughout the year."
    },
    {
        title: "Sinhagad Fort",
        description:
            "Sinhagad Fort is a historic hill fort associated with the bravery of Tanaji Malusare and Chhatrapati Shivaji Maharaj. Offering breathtaking views of the Sahyadri Mountains, traditional Maharashtrian food, and exciting trekking trails, it is a favorite destination for history and nature enthusiasts."
    },
    {
        title: "Aga Khan Palace",
        description:
            "Aga Khan Palace is one of Pune's most significant historical landmarks, renowned for its elegant Italian architecture and its connection with Mahatma Gandhi during India's freedom struggle. The palace also houses a museum featuring photographs, artifacts, and memorabilia from India's independence movement."
    },
    {
        title: "Khadakwasla Dam",
        description:
            "Khadakwasla Dam is a scenic getaway on the outskirts of Pune, known for its peaceful reservoir, beautiful landscapes, and mesmerizing sunset views. Visitors often enjoy local street food, relaxing evenings, and quality time amidst nature."
    },

    {
        title: "Phoenix Marketcity Pune",
        description:
            "Phoenix Marketcity is one of Pune's largest shopping and entertainment destinations, offering premium retail stores, restaurants, cafés, multiplex cinemas, gaming zones, and family entertainment. It is an ideal place for shopping, dining, and spending quality leisure time."
    }
],

"services": [
  {
    "name": "Goa to Pimpri Chinchwad Cab",
    "description": "Book a Goa to Pimpri Chinchwad cab for comfortable long-distance travel with professional drivers and well-maintained vehicles for one-way and round-trip journeys."
  },
  {
    "name": "Goa to Pimpri Chinchwad Taxi",
    "description": "Reliable Goa to Pimpri Chinchwad taxi service offering safe and convenient intercity transportation for families, tourists, and business travelers."
  },
  {
    "name": "Goa to Pimpri Chinchwad Cab Service",
    "description": "Professional Goa to Pimpri Chinchwad cab service with AC vehicles, flexible pickup options, and transparent pricing."
  },
  {
    "name": "Goa to Pimpri Chinchwad Taxi Service",
    "description": "Comfortable Goa to Pimpri Chinchwad taxi service designed for hassle-free travel with experienced chauffeurs and clean vehicles."
  },
  {
    "name": "Goa to Pimpri Chinchwad One Way Cab",
    "description": "Affordable Goa to Pimpri Chinchwad one way cab service allowing passengers to pay only for a single-side trip without return charges."
  },
  {
    "name": "Goa to Pimpri Chinchwad Round Trip Cab",
    "description": "Flexible Goa to Pimpri Chinchwad round trip cab packages suitable for family vacations, business meetings, and weekend travel."
  },
  {
    "name": "Goa to Pimpri Chinchwad Outstation Cab",
    "description": "Reliable Goa to Pimpri Chinchwad outstation cab service for long-distance travel with comfortable vehicles and professional drivers."
  },
  {
    "name": "Goa to Pimpri Chinchwad Cab Booking",
    "description": "Easy Goa to Pimpri Chinchwad cab booking with instant confirmation, multiple vehicle options, and dependable customer support."
  },
  {
    "name": "Goa to Pimpri Chinchwad Online Taxi",
    "description": "Book Goa to Pimpri Chinchwad online taxi service with convenient reservations, transparent pricing, and timely pickups."
  },
  {
    "name": "Goa to Pimpri Chinchwad Innova Cab",
    "description": "Spacious Goa to Pimpri Chinchwad Innova cab service ideal for family trips and group travel with extra luggage space."
  },
  {
    "name": "Goa to Pimpri Chinchwad Ertiga Cab",
    "description": "Affordable Goa to Pimpri Chinchwad Ertiga cab service offering comfortable seating and economical travel for small groups."
  },
  {
    "name": "Goa to Pimpri Chinchwad Sedan Cab",
    "description": "Comfortable Goa to Pimpri Chinchwad sedan cab service perfect for solo travelers, couples, and business professionals."
  },
  {
    "name": "Goa to Pimpri Chinchwad Airport Taxi",
    "description": "Reliable Goa to Pimpri Chinchwad airport taxi service with timely pickups from Goa airports and direct transfers to PCMC."
  },
  {
    "name": "Goa to Pimpri Chinchwad Cab Fare",
    "description": "Get transparent Goa to Pimpri Chinchwad cab fare details including vehicle charges, tolls, and driver allowances."
  },
  {
    "name": "Goa to Pimpri Chinchwad Taxi Fare",
    "description": "Affordable Goa to Pimpri Chinchwad taxi fare plans with upfront pricing and no hidden costs."
  },
  {
    "name": "Goa to Pimpri Chinchwad Cab Price",
    "description": "Check Goa to Pimpri Chinchwad cab price options for sedans, SUVs, and premium vehicles with flexible packages."
  },
  {
    "name": "Best Goa to Pimpri Chinchwad Cab",
    "description": "Best Goa to Pimpri Chinchwad cab service offering professional drivers, clean vehicles, and exceptional customer service."
  },
  {
    "name": "Affordable Goa to Pimpri Chinchwad Taxi",
    "description": "Budget-friendly Goa to Pimpri Chinchwad taxi service providing comfortable travel at competitive prices."
  },
  {
    "name": "Goa to Pimpri Chinchwad Family Cab",
    "description": "Comfortable Goa to Pimpri Chinchwad family cab service with spacious vehicles suitable for group and family travel."
  },
  {
    "name": "Goa to PCMC Cab",
    "description": "Convenient Goa to PCMC cab service for direct travel to Pimpri-Chinchwad with safe and reliable transportation options."
  }
],

"tableData": [
  ["Goa to Pimpri Chinchwad Cab", "Goa to Pimpri Chinchwad Taxi"],
  ["Goa to Pimpri Chinchwad Cab Service", "Goa to Pimpri Chinchwad Taxi Service"],
  ["Goa to Pimpri Chinchwad One Way Cab", "Goa to Pimpri Chinchwad Round Trip Cab"],
  ["Goa to Pimpri Chinchwad Outstation Cab", "Goa to Pimpri Chinchwad Cab Booking"],
  ["Goa to Pimpri Chinchwad Online Taxi", "Goa to Pimpri Chinchwad Innova Cab"],
  ["Goa to Pimpri Chinchwad Ertiga Cab", "Goa to Pimpri Chinchwad Sedan Cab"],
  ["Goa to Pimpri Chinchwad Airport Taxi", "Goa to Pimpri Chinchwad Cab Fare"],
  ["Goa to Pimpri Chinchwad Taxi Fare", "Goa to Pimpri Chinchwad Cab Price"],
  ["Best Goa to Pimpri Chinchwad Cab", "Affordable Goa to Pimpri Chinchwad Taxi"],
  ["Goa to Pimpri Chinchwad Family Cab", "Goa to PCMC Cab"]
],






"whychoose": [
  {
    "WhyChooseheading": "Convenient Intercity Travel",
    "WhyChoosedescription": "Enjoy a hassle-free journey from Goa to Pimpri Chinchwad with comfortable cab services."
  },
  {
    "WhyChooseheading": "Affordable Fare Options",
    "WhyChoosedescription": "Transparent pricing with budget-friendly rates for both one-way and round trips."
  },
  {
    "WhyChooseheading": "Wide Range of Vehicles",
    "WhyChoosedescription": "Choose from Sedan, Ertiga, Innova Crysta, and SUV cabs according to your travel needs."
  },
  {
    "WhyChooseheading": "Direct Pickup Service",
    "WhyChoosedescription": "Pickup available from Goa Airport, hotels, resorts, and residential locations."
  },
  {
    "WhyChooseheading": "Comfortable AC Cabs",
    "WhyChoosedescription": "Travel in clean, sanitized, and well-maintained air-conditioned vehicles."
  },
  {
    "WhyChooseheading": "Experienced Highway Drivers",
    "WhyChoosedescription": "Professional chauffeurs familiar with long-distance and ghat routes ensure a safe ride."
  },
  {
    "WhyChooseheading": "Flexible Booking Options",
    "WhyChoosedescription": "Book one-way drops or round trips based on your schedule and requirements."
  },
  {
    "WhyChooseheading": "24/7 Customer Assistance",
    "WhyChoosedescription": "Dedicated support team available anytime for bookings and travel queries."
  }
]
};

const faqData = [
  {
    question: 'Does Lotus Cab provide Goa to Pimpri Chinchwad cab service?',
    answer: 'Yes, Lotus Cab offers reliable Goa to Pimpri Chinchwad cab services for both one-way and round-trip journeys.'
  },
  {
    question: 'What is the distance between Goa and Pimpri Chinchwad by cab?',
    answer: 'The distance from Goa to Pimpri Chinchwad is approximately 450 to 470 km, and the journey usually takes around 8 to 10 hours.'
  },
  {
    question: 'What are the charges for Goa to Pimpri Chinchwad cab booking?',
    answer: 'Cab charges depend on the vehicle category, travel date, and trip type. Lotus Cab offers transparent pricing with no hidden costs.'
  },
  {
    question: 'Can I book a one-way cab from Goa to Pimpri Chinchwad?',
    answer: 'Yes, we provide affordable one-way cab services, allowing customers to pay only for the required journey.'
  },
  {
    question: 'Which vehicles are available for this route?',
    answer: 'We offer Sedan cars, Ertiga, Innova Crysta, and SUVs suitable for solo travelers, families, and groups.'
  },
  {
    question: 'Is airport pickup available in Goa?',
    answer: 'Yes, Lotus Cab provides pickup services from Goa Airport, railway stations, hotels, and other major locations.'
  },
  {
    question: 'Are toll and state taxes included in the fare?',
    answer: 'Toll charges, parking fees, and state taxes are generally charged separately and are informed before booking confirmation.'
  },
  {
    question: 'Is night travel available from Goa to Pimpri Chinchwad?',
    answer: 'Yes, our cab service operates day and night with experienced drivers for safe long-distance travel.'
  },
  {
    question: 'Can I book a round trip between Goa and Pimpri Chinchwad?',
    answer: 'Absolutely. We provide flexible round-trip packages for business, family, and leisure travelers.'
  },
  {
    question: 'How can I book Goa to Pimpri Chinchwad Cab with Lotus Cab?',
    answer: 'Simply share your pickup location, travel date, number of passengers, and preferred vehicle to receive instant fare details and booking confirmation.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Kunal Jadhav',
    feedback: 'After our Goa vacation, we needed a direct ride to Pimpri Chinchwad. Lotus Cab arranged a comfortable Innova and the entire journey was smooth and relaxing.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Priya Kulkarni',
    feedback: 'Traveling with luggage and family was easy thanks to Lotus Cab. The driver was courteous, arrived on time, and made the long journey completely stress-free.',
    rating: 5,
  },
];









































































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune Taxi Fare", link: "Pune-Taxi-Fare" },
  { place: "/images/keyword/2.jpg", text: "Pune Outstation Taxi Hire", link: "Pune-Outstation-Taxi-Hire" },
  { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad Online Cab", link: "Pimpri-Chinchwad-Online-Cab" },
  { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
  { place: "/images/keyword/5.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
  { place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "Pune-to-Mahabaleshwar-Cabs" },
  { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab Booking", link: "Pune-to-Lonavala-Cab-Booking" },
  { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cabs", link: "Pune-to-Shirdi-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Pune to Lavasa City Cabs", link: "Pune-to-Lavasa-City-Cabs" },
  { place: "/images/keyword/11.jpg", text: "Pune Airport to Bhimashankar Cabs", link: "Pune-Airport-to-Bhimashankar-Cabs" },
  { place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cabs", link: "Pune-to-Konkan-Darshan-Cabs" },
  { place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
  { place: "/images/keyword/15.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
  { place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab Booking", link: "Pune-to-Panchgani-Cab-Booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Taxi", link: "Pune-to-Mumbai-International-Airport-Taxi" },
  { place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab Package", link: "Ashtavinayak-Darshan-Cab-Package" },
  { place: "/images/keyword/19.jpg", text: "Pune To Nagpur Cabs", link: "Pune-To-Nagpur-Cabs" },
  { place: "/images/keyword/20.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
  { place: "/images/keyword/21.jpg", text: "Taxi Service in Hinjewadi Pune", link: "Taxi-Service-in-Hinjewadi-Pune" },
  { place: "/images/keyword/22.jpg", text: "Pune to Gujarat Cab Service", link: "Pune-to-Gujarat-Cab-Service" },
  { place: "/images/keyword/23.jpg", text: "Travel Agents in Pune", link: "Travel-Agents-in-Pune" },
  { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Bangalore Taxi Service", link: "Pune-to-Bangalore-Taxi-Service" },

];






const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Goa to Pimpri Chinchwad Cab",
"image": "https://lotuscab.com/assets/images/goa-to-pimpri-chinchwad-cab.jpg",
"description": "Book Goa to Pimpri Chinchwad Cab with Lotus Cab for safe, comfortable, and affordable outstation travel. Choose from sedan, Ertiga, Innova, Innova Crysta, and SUV cabs for one way, round trip, airport transfers, and family travel with professional drivers available 24x7.",
"brand": {
"@type": "Brand",
"name": "Lotus Cab"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "7215"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹18/Km",
"availability": "https://schema.org/InStock",
"url": "https://lotuscab.com/goa-to-pimpri-chinchwad-cab"
}
};








  return (
    <div>
      

<Helmet>
  <title>Goa to Pimpri Chinchwad Cab | One Way & Outstation Taxi | +91 8767592195</title>

<meta
 name="description"
 content="Book Goa to Pimpri Chinchwad Cab with Lotus Cab for reliable and comfortable outstation travel. One way, round trip, airport taxi, sedan, Ertiga, Innova, and SUV cab services available at affordable fares with 24x7 professional drivers."
/>

<meta
 name="keywords"
 content="Goa to Pimpri Chinchwad Cab, Goa to Pimpri Chinchwad Taxi, Goa to Pimpri Chinchwad Cab Service, Goa to Pimpri Chinchwad Taxi Service, Goa to Pimpri Chinchwad One Way Cab, Goa to Pimpri Chinchwad Round Trip Cab, Goa to Pimpri Chinchwad Outstation Cab, Goa to Pimpri Chinchwad Cab Booking, Goa to Pimpri Chinchwad Online Taxi, Goa to Pimpri Chinchwad Innova Cab, Goa to Pimpri Chinchwad Ertiga Cab, Goa to Pimpri Chinchwad Sedan Cab"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>






 <section className="page-header">
      
      {/* Background Image */}
      <div
        className="page-header__bg"
        style={{
          backgroundImage:
            "url(../images/page-header-bg-1-1.jpg)",
        }}
      ></div>
      <div className="container">
        <div className="page-header__content">
        
          <h2 className="page-header__title"> {cardData.keyword}</h2>
        </div>
      </div>
    </section>


      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/93.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Lotus Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Lotus Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918767592195" className="pc-call">+91 8767592195</a>
                      <a href="tel:+919172145909" className="pc-call">+91 9172145909</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918767592195"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918767592195" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@lotuscab.com" className="pc-email">
                      booking@lotuscab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Lotus Cab </strong><br />
                    Mauli Krupa building,
                    Sant Tukaram Nagar Gali No.1,
                    Navi sangvi MK chauk -411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Goatopimprichichwad;